module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"あなた":"あなた","全体平均":"全体平均","運動":"運動","食事":"食事","飲酒":"飲酒","睡眠":"睡眠","ストレス":"ストレス"},"en":{"あなた":"You","全体平均":"Average","運動":"Exercise","食事":"Meal","飲酒":"Drinking","睡眠":"Sleep","ストレス":"Stress"}}')
  delete Component.options._Ctor
}
